import { AlertCircle } from 'lucide-react';
import { FC } from 'react';

import { PunchupButton } from 'features/common/components/Punchup/primitives/buttons/PunchupButton';
import styles from './PunchupErrorState.module.css';

export interface PunchupErrorStateProps {
	title: string;
	description?: string;
	onRetry?: () => void;
	retryLabel?: string;
}

export const PunchupErrorState: FC<PunchupErrorStateProps> = ({
	title,
	description,
	onRetry,
	retryLabel = 'Try again',
}) => (
	<div className={styles.container}>
		<div className={styles.iconCircle}>
			<AlertCircle className={styles.icon} aria-hidden="true" />
		</div>
		<p className={styles.title}>{title}</p>
		{description && <p className={styles.description}>{description}</p>}
		{onRetry && <PunchupButton variant="outline" type="button" onClick={onRetry} text={retryLabel} />}
	</div>
);
